import React, { useEffect, useRef } from 'react';
import clsx from 'clsx';
import styles from './styles.css.js';
import Icon from '../../icon';
import ItemsList from '../items-list';
import Dropdown from '../../internal/components/dropdown';
import { useButtonDropdown } from '../utils/use-button-dropdown';
var ExpandableCategoryElement = function (_a) {
    var _b, _c, _d;
    var item = _a.item, onItemActivate = _a.onItemActivate, highlightedItem = _a.highlightedItem, expandedItem = _a.expandedItem, disabled = _a.disabled, onItemClick = _a.onItemClick;
    var highlighted = item === highlightedItem;
    var expanded = item === expandedItem;
    var triggerRef = React.useRef(null);
    var usingMouse = useRef(true);
    var _e = useButtonDropdown({
        items: item.items,
        hasExpandableGroups: false,
        onItemClick: onItemClick,
        isChild: true,
        usingMouse: usingMouse
    }), internalHighlightedItem = _e.highlightedItem, onKeyDown = _e.onKeyDown, onKeyUp = _e.onKeyUp, resetHighlight = _e.resetHighlight;
    useEffect(function () {
        if (item === highlightedItem && item !== expandedItem && triggerRef.current) {
            triggerRef.current.focus();
            resetHighlight();
        }
    }, [item, highlightedItem, expandedItem]);
    var triggerClickHandler = function (e) {
        if (!disabled) {
            e.preventDefault();
            onItemActivate(item);
            if (triggerRef.current) {
                triggerRef.current.focus();
                resetHighlight();
            }
        }
    };
    // Hide the category title element from screen read/ers because it will be
    // provided as an ARIA label.
    var trigger = item.text && (React.createElement("p", { onClick: triggerClickHandler, className: clsx(styles.header, (_b = {}, _b[styles.disabled] = disabled, _b), styles['expandable-header'], (_c = {},
            _c[styles.highlighted] = highlighted,
            _c)), "data-testid": item.id, 
        // We are using the roving tabindex technique to manage the focus state of the dropdown.
        // The current element will always have tabindex=0 which means that it can be tabbed to,
        // while all other items have tabindex=-1 so we can focus them when necessary.
        tabIndex: item.disabled ? undefined : highlighted ? 0 : -1, ref: triggerRef },
        item.text,
        React.createElement("span", { className: clsx(styles['expand-icon'], styles['expand-icon-right']) },
            React.createElement(Icon, { name: "caret-down-filled" }))));
    return (React.createElement("li", { className: clsx(styles.category, styles.expandable, (_d = {},
            _d[styles.expanded] = expanded,
            _d[styles.disabled] = disabled,
            _d[styles.highlighted] = highlighted || expanded,
            _d)), "aria-disabled": disabled ? 'true' : undefined, onKeyDown: onKeyDown, onKeyUp: onKeyUp },
        React.createElement(Dropdown, { open: expanded, stretchWidth: false, interior: true, trigger: trigger },
            React.createElement("ul", { role: "group", "aria-label": item.text, className: clsx(styles['items-list-container']) }, item.items && expanded && (React.createElement(ItemsList, { items: item.items, onItemActivate: onItemActivate, expandedItem: expandedItem, highlightedItem: internalHighlightedItem, categoryDisabled: disabled, onItemClick: onItemClick }))))));
};
export default ExpandableCategoryElement;
